<template>
    <update-base>
        <div v-if="shop_status == null || shop_status !== gatewayStatus.ACTIVE">
            <div class="alert alert-warning my-3" v-text="$t('stakeholders.label.your_gateway_is_not_active')"></div>
        </div>
        <div v-else>
            <div class="alert alert-danger mb-4" v-if="has_error" v-text="error_text"></div>
            <div v-if="!has_created_request">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <label for="add_stakeholder" v-text="$t('stakeholders.label.add_stakeholder_to_shop')"></label>
                        <select class="form-control kt-selectpicker"
                                id="add_stakeholder"
                                name="add_stakeholder"
                                v-model="new_stakeholder">
                            <option :key="index" :value="item" v-for="(item, index) in all_stakeholders">
                                <span>{{ item.full_name }} ({{ item.id }})</span>
                            </option>
                        </select>
                    </div>
                </div>
                <div class="mt-3">
                    <button @click="add_new_stakeholder()" class="btn btn-primary  mr-3" type="button"
                            v-text="$t('btn.add')"></button>
                    <button @click="sync_shop_stakeholders()" class="btn btn-success" type="button"
                            v-text="$t('btn.send_request')"></button>
                </div>
            </div>
            <div class="alert alert-info my-3" v-else v-text="$t('stakeholders.label.you_have_pending_request')"></div>
            <div class="line-divider mt-4 mb-3"></div>
            <div class="text-center">
                <table class="table">
                    <thead>
                    <tr>
                        <th v-text="$t('label.identifier')"></th>
                        <th v-text="$t('label.full_name')"></th>
                        <th v-text="$t('label.phone')"></th>
                        <th v-text="$t('label.sheba_numbers')"></th>
                        <th v-text="$t('label.merchant_type')"></th>
                        <th v-text="$t('label.status')"></th>
                        <th v-text="$t('label.attachment_status')"></th>
                        <th v-if="!has_created_request" v-text="$t('datatable.actions')"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="index" v-for="(item, index) in stakeholders">
                        <td v-text="item.id"></td>
                        <td v-text="item.full_name"></td>
                        <td v-text="item.cellphone_number"></td>
                        <td>
                            <!-- Button trigger modal -->
                            <button :data-target="`#shebaModal${index}`" class="btn btn-info p-1" data-toggle="modal"
                                    type="button">
                                <small v-text="$t('label.details')"></small>
                            </button>

                            <!-- Modal -->
                            <div :id="`shebaModal${index}`" class="modal fade" tabindex="-1">
                                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                                    <div class="modal-content">
                                        <div class="modal-body">
                                            <table class="table table-bordered">
                                                <tr>
                                                    <td v-text="$t('label.identifier')"></td>
                                                    <td v-text="$t('label.sheba_number')"></td>
                                                </tr>
                                                <tr :key="sheba_index"
                                                    v-for="(item, sheba_index) in item.sheba_numbers">
                                                    <td v-text="item.id"></td>
                                                    <td v-text="item.number"></td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td v-text="merchant_type_str.get(item.merchant_type)"></td>
                        <td>
                            <span :class="`badge badge-${stakeholder_variant(item.status)}`"
                                  v-text="stakeholder_status_str.get(item.status)"></span>
                        </td>
                        <td>
                            <span :class="`badge badge-${stakeholder_shop_variant(item.shop_attachment_status)}`"
                                  v-text="stakeholder_shop_status_str.get(item.shop_attachment_status)"></span>
                        </td>
                        <td v-if="!has_created_request">
                            <button @click="deleteRow(index)" class="btn btn-sm p-1 m-0 btn-danger" type="button">
                                <i class="la la-trash-o p-0"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </update-base>
</template>

<script>
    import UpdateBase from './components/allotment-update-base';
    import $ from 'jquery';
    import {i18n} from '@/plugins/i18n';
    import {stakeholdersService} from '@/common/api.service';
    import {merchantType, merchantTypeStr} from '@/constants/merchantType';
    import {stakeholderStatusStr, stakeholderVariant} from '@/constants/stakeholderStatus';
    import {stakeholderShopStatusStr, stakeholderShopVariant} from '@/constants/StakeholderShopAttachmentStatus';
    import {gatewayStatus} from "@/constants/gatewayStatus";

    export default {
        components: {
            UpdateBase,
        },
        data() {
            return {
                gatewayStatus: gatewayStatus,
                shop_status: null,
                has_error: false,
                error_text: '',
                has_created_request: false,
                stakeholders: [],
                all_stakeholders: [],
                new_stakeholder: null,
                merchant_type: merchantType,
                merchant_type_str: merchantTypeStr,
                stakeholder_status_str: stakeholderStatusStr,
                stakeholder_variant: stakeholderVariant,
                stakeholder_shop_status_str: stakeholderShopStatusStr,
                stakeholder_shop_variant: stakeholderShopVariant,
            };
        },
        mounted() {
            stakeholdersService.get_shop_stakeholders(this.$route.params.hashid).then(response => {
                this.has_created_request = response.data.data.has_created_request;
                this.shop_status = response.data.data.shop_status;
                this.stakeholders = response.data.data.stakeholders;

                stakeholdersService.get_all_stakeholders().then(response => {
                    this.all_stakeholders = response.data.data;
                }).finally(() => {
                    this.init_select_picker();
                });
            });
        },
        methods: {
            add_new_stakeholder() {
                if (this.new_stakeholder != null && this.new_stakeholder != '') {
                    this.stakeholders.push({
                        cellphone_number: this.new_stakeholder.cellphone_number,
                        full_name: this.new_stakeholder.full_name,
                        id: this.new_stakeholder.id,
                        merchant_type: this.new_stakeholder.merchant_type,
                        status: this.new_stakeholder.status,
                    });
                }
            },
            sync_shop_stakeholders() {
                let stakeholders_ids = [];

                for (let i = 0; i < this.stakeholders.length; ++i) {
                    stakeholders_ids.push(this.stakeholders[i].id);
                }

                let params = {
                    selected_stakeholders: stakeholders_ids,
                };

                stakeholdersService.update_shop_stakeholders(params, this.$route.params.hashid).then(response => {
                    this.has_error = false;
                    this.$router.push('/gateways');
                }).catch(({response}) => {
                    this.error_text = response.data.message;
                    this.has_error = true;
                });
            },
            deleteRow(index) {
                this.stakeholders.splice(index, 1);
            },
            init_select_picker() {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                });
            }
        },
    }
</script>
